import { createSlice } from '@reduxjs/toolkit';

interface AppState {
  plcHasSectors: boolean;
  plcHasSectorsLoaded: boolean;
  hasPaymentRefund: boolean;
}

const initialState: AppState = {
  hasPaymentRefund: false,
  plcHasSectors: false,
  plcHasSectorsLoaded: false
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setAppHasPaymentRefund: (state, action) => {
      state.hasPaymentRefund = action.payload;
    },
    setPlcHasSectors: (state, action) => {
      state.plcHasSectors = action.payload;
    },
    setPlcHasSectorsLoaded: (state, action) => {
      state.plcHasSectorsLoaded = action.payload;
    }
  }
});

export const { setAppHasPaymentRefund, setPlcHasSectors, setPlcHasSectorsLoaded } = appSlice.actions;
